<template>
    <vs-popup class="holamundo" :active.sync="responsePopupData.show" :buttons-hidden="true">
      <div class="text-center px-6 py-10 md:p-10">
        <img v-if="responsePopupData.type === 'success'" class="text-center" src="@/assets/images/success.png" />

        <img v-if="responsePopupData.type === 'error'" class="text-center" src="@/assets/images/remove.svg" />

        <div class="popup-body md:popup-body mb-4 ml-0" v-html="responsePopupData.body"></div>

        <vs-button class="ok-btn md:ok-btn" @click="$emit('hide-response-popup')">{{ $t('Ok') }}</vs-button>
      </div>
    </vs-popup>
</template>

<script>
export default {
  name: 'speakol-response-popup',

  props: {
    /*
      {
        type: '' // success, error,
        body: "the message",
        show: true & false
      }
    */
    responsePopupData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .popup-body {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 0.1px;
  }

  .ok-btn {
    border-radius: 3px;
    margin-top: 20px;
    height: 40px;
    background: #0092d7;

    @apply w-full;
  }

  @media (min-width: 768px) {
    .md\:ok-btn {
      width: 185px;
    }

    .md\:popup-body {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 0.1px;
    }
  }

</style>
